<template>
  <div class="dashboard-title dashboard-title--basic mb-lg">
    <div class="dashboard-title__actions" style="align-items: flex-start;">
      <div class="relative w-100">
        <div style="display: flex; align-items: center;">
          <h1
            class="fw-bold fs-xl"
            style="margin: 0; padding: .5rem 0; color: #102042;"
          >
            {{ heading }}
          </h1>
          <div
            v-if="mainBadge"
            class="badge"
            :class="mainBadge.class"
            :style="mainBadgeCssVars"
          >
            {{ mainBadge.text }}
          </div>
          <div
            v-if="featuredBadge"
            class="badge featured"
            :style="featuredBadgeCssVars"
            style="margin-left: 8px"
          >
            <i class="fa fa-star featuredStar" />
            Featured
          </div>
        </div>
        <div style="display: flex; align-items: center;">
          <LinkWithSVGs v-if="profileLink" v-bind="profileLink" />
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import LinkWithSVGs from '@/components/Dashboard/LinkWithSVGs';
export default {
  computed: {
    mainBadgeCssVars() {
      const colors = { ...this.colors, ...this.mainBadge.colors };
      return {
        '--color': colors[this.mainBadge.class],
      };
    },
    featuredBadgeCssVars() {
      const colors = { ...this.colors, ...this.mainBadge.colors };
      return {
        '--color-featured': colors['featured'],
        '--color-featured-star': colors['featuredStar'],
      };
    },
  },
  components: { LinkWithSVGs },
  data() {
    return {
      colors: {
        hiddenStatus: '#c9cccf',
        searchable: '#acecf6',
        public: '#aee9d1',
        featured: '#fff6a9',
        featuredStar: '#dcb900',
      },
    };
  },
  props: {
    heading: String,
    featuredBadge: Boolean,
    mainBadge: {
      text: String,
      class: String,
      colors: Object,
    },
    profileLink: Object,
  },
};
</script>

<style lang="scss" scoped>
.badge {
  padding: 2px 12px;
  border-radius: 999px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  margin-left: 16px;
  color: #202223;

  &.hiddenStatus,
  &.searchable,
  &.public {
    background-color: var(--color);
  }
  &.featured {
    background-color: var(--color-featured);

    .featuredStar {
      color: var(--color-featured-star);
      margin-right: 4px;
    }
  }
  .star-icon {
    display: inline;
  }
}
</style>
